import { ORDER_FIELDS } from '@/graphql/queries/orders';
import { CLAIM_FIELDS } from '@/graphql/fragments/claims';
import { gql } from '@apollo/client';
import { ITEM_FIELDS } from '@/graphql/queries/items';
import { CLIENT_FIELDS } from '@/graphql/queries/clients';

export const QUERY_ORDERS = gql`
    ${ORDER_FIELDS}
    ${ITEM_FIELDS}
    ${CLIENT_FIELDS}
    query GetOrders($where: orders_bool_exp) {
        orders(where: $where, limit: 25) {
            ...OrderFields
            itemsByOrderId {
                ...ItemFields
            }
            order_carrier {
                ...ClientFields
            }
            order_middle_mile_carrier {
                ...ClientFields
            }
            order_shipper {
                ...ClientFields
            }
            claims {
                claim_id
                claim_number
                claim_status
            }
        }
    }
`;

export const UPSERT_CLAIM = gql`
    ${CLAIM_FIELDS}
    mutation UpsertClaim(
        $claim: claims_insert_input!
        $claim_items: [claim_items_insert_input!]!
        $claim_item_removals: [uuid!] = []
    ) {
        insert_claims_one(
            object: $claim
            on_conflict: {
                constraint: claims_pkey
                update_columns: [
                    claim_status
                    claim_type
                    freight_amount
                    rejection_reason
                    incident_date
                    requested_by
                ]
            }
        ) {
            ...ClaimFields
        }
        insert_claim_items(
            objects: $claim_items
            on_conflict: {
                constraint: claim_items_pkey
                update_columns: [reason, amount, description, images, documents]
            }
        ) {
            affected_rows
            returning {
                ...ClaimItemFields
            }
        }
        delete_claim_items(where: { claim_item_id: { _in: $claim_item_removals } }) {
            affected_rows
            returning {
                claim_item_id
            }
        }
    }
`;
